module.exports = __webpack_public_path__ + "static/media/Send.6d868bb9.svg";